import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import logo from '../../assets/logo.png';
import { siteName } from '../../assets/themes';

const useStyles = makeStyles((theme) => ({
  logoHolder: {
    width: '100%',
    height: 50,
    textAlign: 'center',
  },
  logo: {
    height: 30,
    paddingTop: theme.spacing(1),
    flexGrow: 1,
  },
}));

const Logo = () => {
  const classes = useStyles();

  return (
    <div className={classes.logoHolder}>
      <img
        alt={`${siteName} Logo`}
        className={classes.logo}
        src={logo}
      />
    </div>
  );
};

export default Logo;
